












































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import LayoutMain from '@/layputs/LayoutMain.vue';
import BaseCardRestaurantAdvanced from '@/ui/BaseCardRestaurantAdvanced.vue';
import TheTownSelect from '@/components/addresses/TheTownSelect.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
// Importing function
import {APILookUp, getTags} from '@/ts/other/additional';

export default {
    name: 'PageCartCheckout',
    components: {
        TheTownSelect,
        BaseCardRestaurantAdvanced,
        BaseLoadingAnimation,
        BaseButton,
        LayoutMain,
    },
    props: {},
    data() {
        return {
            ekatte: String(),
            tags: Array(),
            selectedTags: Array(),
            search: String(),
            results: Array(),
        };
    },
    methods: {},
    computed: {},
    mounted() {
        if (this.$route.params.tag !== '') {
            this.selectedTags.push(this.$route.params.tag);
        }
        if (this.$route.params.ekatte !== '') {
            this.ekatte = this.$route.params.ekatte;
        }
        // this.ekatte = this.$route.params.ekatte;
        this.$store.dispatch('setLoadingOn');
        getTags().then((response) => {
            this.tags = response;
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
    watch: {
        // look up in the API
        search(value) {
            if (value.length > 2) {
                APILookUp(value).then((response: any) => {
                    this.results = response.data.data;
                });
            }
            if (value.length === 0) {
                this.results = [];
            }
        },
    },
};
